import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'set-form-input-required' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the form input element to set the required status on. Must be one of: FormCheckboxInput, FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, or FormTextInput.'
  ),
  required: z
    .boolean()
    .describe(
      'Whether the form input should be required. True means the user must fill out this field before submitting the form.'
    ),
});

export const setFormInputRequiredTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Set form input required status',
  llmTool: {
    name: toolName,
    description: dedent`
      Set the required status of a form input element. When set to true, the input
      becomes mandatory and prevents form submission until filled out. When false,
      the input becomes optional. Works with form input types: FormCheckboxInput,
      FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, and FormTextInput.
      Returns null when the required status is successfully set. Required fields
      improve data collection and user experience.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: true, // Modifies form validation behavior, requires confirmation
  timeout: 30000, // 30 seconds for setting required status
});
